export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";